import React, { useState, useEffect } from "react";
import WishlistService from "../../services/wishlist";
import { useClientAuth } from "../../context/ClientAuthContext";
import Header from "../../components/appLayout/header";
import "./index.scss";
import { CartIcon2 } from "../../assets/icons/CartIcon2";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";

const wishlistService = new WishlistService();

const WishlistPage = () => {
  const [wishlist, setWishlist] = useState([]);
  const { currentClient } = useClientAuth();
  const { addToCart } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWishlist = async () => {
      if (!currentClient?.userId) return;
      const data = await wishlistService.getUserWishlist(currentClient.userId);
      setWishlist(data.data);
    };
    fetchWishlist();
  }, [currentClient?.userId]);

  const handleRemove = async (productId) => {
    await wishlistService.removeFromWishlist({
      userId: currentClient?.userId,
      productId,
    });
    setWishlist(wishlist.filter((item) => item.productId._id !== productId));
  };

  const handleAddToCart = (product) => {
    const now = new Date();
    const promoStart = product?.promoStartDate
      ? new Date(product.promoStartDate)
      : null;
    const promoEnd = product?.promoEndDate
      ? new Date(product.promoEndDate)
      : null;

    const isPromoActive =
      product?.isOnPromo &&
      promoStart &&
      promoEnd &&
      now >= promoStart &&
      now <= promoEnd;

    let finalPrice = product.ttc;
    if (isPromoActive && product.pourcentagePromo) {
      finalPrice = (product.ttc * (100 - product.pourcentagePromo)) / 100;
    }

    const imageUrls =
      product?.imagePrincipale?.map(
        (_, index) =>
          `http://localhost:3005/products/${product._id}/image/${index}`
      ) || [];

    addToCart({
      _id: product._id,
      title: product.title,
      price: finalPrice,
      quantity: 1,
      quantite: product.quantite,
      image: imageUrls[0],
    });
  };

  return (
    <>
      <div className="wishlist-header p-md-5 p-3">
        <Header />
      </div>

      <div className="wishlist-container container">
        <h2 className="wishlist-title">Ma Wishlist</h2>

        {wishlist.length === 0 ? (
          <p className="wishlist-empty">Votre wishlist est vide.</p>
        ) : (
          <ul className="wishlist-list row">
            {wishlist.map((item) => {
              const product = item.productId;

              const now = new Date();
              const promoStart = product?.promoStartDate
                ? new Date(product.promoStartDate)
                : null;
              const promoEnd = product?.promoEndDate
                ? new Date(product.promoEndDate)
                : null;
              const isPromoActive =
                product?.isOnPromo &&
                promoStart &&
                promoEnd &&
                now >= promoStart &&
                now <= promoEnd;

              let finalPrice = product.ttc;
              if (isPromoActive && product.pourcentagePromo) {
                finalPrice =
                  (product.ttc * (100 - product.pourcentagePromo)) / 100;
              }

              return (
                <li
                  key={item._id}
                  className="wishlist-item col-md-4 col-sm-6 mb-4">
                  <div className="product-card">
                    <div className="image-container">
                      <img
                        src={`http://localhost:3005/products/${
                          product?._id
                        }/image/${0}`}
                        alt={product.title}
                        className="product-img"
                        style={{ opacity: 1 }}
                        onClick={() => {
                          navigate(`/details-product/${product._id}`);
                          window.scrollTo(0, 0);
                        }}
                      />

                      <button
                        className="cart-icon"
                        onClick={() => {
                          if (product.quantite > 0) {
                            handleAddToCart(product);
                          } else {
                            alert("Produit en rupture de stock");
                          }
                        }}>
                        <CartIcon2 />
                      </button>
                    </div>
                    {isPromoActive && (
                      <div className="promo-badge">
                        {product.pourcentagePromo}%
                      </div>
                    )}
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="product-title">{product.title}</div>

                      <div className="price">
                        {isPromoActive ? (
                          <>
                            {finalPrice.toFixed(3)} <span> DT</span>
                            <span className="old-price ms-3">
                              {product.ttc.toFixed(3)} DT
                            </span>
                          </>
                        ) : (
                          <>
                            {product.ttc.toFixed(3)} <span> DT</span>
                          </>
                        )}
                      </div>
                    </div>{" "}
                    <button
                      className="wishlist-remove-btn"
                      onClick={() => handleRemove(product._id)}>
                      🗑
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};

export default WishlistPage;
